module.exports = __webpack_public_path__ + "static/media/Jaques Van Der Hyde.1984fdba.JPG";